import React from "react"
import { withStyles, makeStyles, useTheme } from "@material-ui/core/styles"
import Dialog from "@material-ui/core/Dialog"
import { useTranslation } from "react-i18next"
import MuiDialogTitle from "@material-ui/core/DialogTitle"
import DialogContent from "@material-ui/core/DialogContent"
import IconButton from "@material-ui/core/IconButton"
import CloseIcon from "@material-ui/icons/Close"
import Typography from "@material-ui/core/Typography"
import AddUser from "./AddUser"
import EditUser from "./EditUser"

function UserAddEditModel(props) {
	const { open, onClose, userData } = props
	const [t] = useTranslation("global")
	const theme = useTheme()

	const isAddMode = !props?.userData?.userid

	const useStyles = makeStyles((theme) => ({
		root: {
			padding: theme.spacing(2),
			width: "360px",
			height: "55px",
			"& .MuiTypography-h6": {
				...theme.typography.body2,
				paddingBottom: 1,
			},
		},
		closeButton: {
			position: "absolute",
			right: theme.spacing(1),
			top: 2,
			color: theme.palette.grey[500],
		},
		dialogContent: {
			padding: theme.spacing(2),
		},
	}))

	const classes = useStyles()

	return (
		<Dialog style={{ ...theme.typography.body2 }} onClose={onClose} aria-labelledby="user-dialog-title" open={open}>
			<MuiDialogTitle className={classes.root}>
				<Typography noWrap>{isAddMode ? t("user.add.title") : t("user.edit.title")}</Typography>
				{onClose ? (
					<IconButton aria-label={t("user.dialogLabel")} className={classes.closeButton} onClick={onClose}>
						<CloseIcon />
					</IconButton>
				) : null}
			</MuiDialogTitle>
			<DialogContent dividers className={classes.dialogContent}>
				<AddUser isAddMode={isAddMode} userData={userData} closeDialog={onClose} />
			</DialogContent>
		</Dialog>
	)
}

export default UserAddEditModel
